// extracted by mini-css-extract-plugin
export default {"triggerStyles":"column_triggerStyles__HkwYW","link":"column_link__wdIsk","triggerChildren":"column_triggerChildren__7qZoo"};